import { lazy, Suspense } from "react";
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import Home from "./pages/Dashboard";

import Main from "./components/layout/Main";
import "./assets/styles/main.css";
import "./assets/styles/theme.css";
import "./assets/styles/responsive.css";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ErrorBoundry from "./commons/ErrorBoundry";

import { useSelector } from "react-redux";

const UpdateAccount = lazy(() => import("./pages/UpdateAccount"));
const SignIn = lazy(() => import("./pages/SignIn"));

//this will provide protected routes for privileged users
const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/sign-in",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

//this will provide public routes for other users
function PublicRoute({ children, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

function App() {
  const isLoggedIn = useSelector((state) => state.authenticate.isLoggedIn);

  return (
    <div className="App">
     
      <Router>
      <ErrorBoundry>
        <Suspense
          fallback={
            <Spin
              direction="vertical"
              indicator={antIcon}
              style={{
                width: "100%",
                margin: "30% 0",
                marginBottom: "20px",
                padding: "30px 50px",
                textAlign: "center",
                borderRadius: "4px",
              }}
            />
          }
        >
        
            <Switch>
              <Route exact path="/">
                <Redirect to="/sign-in" />
              </Route>
              <PublicRoute path="/sign-in" isAuthenticated={isLoggedIn}>
                <SignIn />
              </PublicRoute>
              {/* <PublicRoute path="/sign-up" isAuthenticated={isLoggedIn}>
              <SignUp />
            </PublicRoute> */}
              <PublicRoute
                path="/update-account/:userId/:name/:role/:token/:username/:password"
                isAuthenticated={isLoggedIn}
              >
                <UpdateAccount />
              </PublicRoute>
              <PublicRoute path="/update-account" isAuthenticated={isLoggedIn}>
                <UpdateAccount />
              </PublicRoute>
              <Main>
                <ProtectedRoute
                  exact
                  path="/dashboard"
                  component={Home}
                  isAuthenticated={isLoggedIn}
                />
              </Main>
            </Switch>
        
        </Suspense>
        </ErrorBoundry>
      </Router>
    </div>
  );
}

export default App;
